// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Seychelles from '../_raw/flag/icon_flag_seychelles.png';

export default () => <img src={Seychelles} alt="Seychelles" />;
